/**
 * @generated SignedSource<<7c5117a68e6bbf1c2e3a15693aebba2a>>
 * @relayHash 2ed42f13b9dee55bec59c457b2b40267
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6682ac2a0f141c2c47c17b07f965669530319e5d7dd3dd5b937e8416fcd952c4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type insightsDevelopmentQuery$variables = {
  cloudId: string;
  endAtExclusive: AGG$DateTime;
  projectAri: string;
  projectId: string;
  prsCreatedAfter: AGG$DateTime;
  startFromInclusive: AGG$DateTime;
  timezoneId: string;
};
export type insightsDevelopmentQuery$data = {
  readonly devOpsMetrics: {
    readonly cycleTime: {
      readonly cycleTimeMetrics: ReadonlyArray<{
        readonly data: ReadonlyArray<{
          readonly cycleTimeSeconds: AGG$Long | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly graphStore: {
    readonly projectAssociatedPr: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly projectAssociatedVulnerability: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type insightsDevelopmentQuery = {
  response: insightsDevelopmentQuery$data;
  variables: insightsDevelopmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endAtExclusive"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prsCreatedAfter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startFromInclusive"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timezoneId"
},
v7 = {
  "is": [
    "OPEN"
  ]
},
v8 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "projectAri"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "totalCount"
  }
],
v10 = {
  "concreteType": "GraphStore",
  "kind": "LinkedField",
  "name": "graphStore",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "after",
                      "variableName": "prsCreatedAfter"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "createdAt"
                },
                {
                  "kind": "Literal",
                  "name": "to_status",
                  "value": (v7/*: any*/)
                }
              ],
              "kind": "ObjectValue",
              "name": "and"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        (v8/*: any*/)
      ],
      "concreteType": "GraphStoreSimplifiedProjectAssociatedPrConnection",
      "kind": "LinkedField",
      "name": "projectAssociatedPr",
      "plural": false,
      "selections": (v9/*: any*/)
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "and": {
              "to_severity": {
                "is": [
                  "CRITICAL"
                ]
              },
              "to_status": (v7/*: any*/)
            }
          }
        },
        (v8/*: any*/)
      ],
      "concreteType": "GraphStoreSimplifiedProjectAssociatedVulnerabilityConnection",
      "kind": "LinkedField",
      "name": "projectAssociatedVulnerability",
      "plural": false,
      "selections": (v9/*: any*/)
    }
  ]
},
v11 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "endAtExclusive",
        "variableName": "endAtExclusive"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "jiraProjectIds.0",
            "variableName": "projectId"
          }
        ],
        "kind": "ListValue",
        "name": "jiraProjectIds"
      },
      {
        "kind": "Literal",
        "name": "resolution",
        "value": {
          "unit": "WEEK",
          "value": 1
        }
      },
      {
        "kind": "Variable",
        "name": "startFromInclusive",
        "variableName": "startFromInclusive"
      },
      {
        "kind": "Variable",
        "name": "timezoneId",
        "variableName": "timezoneId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "isIncludeCycleTimeMean",
    "value": true
  }
],
v12 = {
  "concreteType": "DevOpsMetricsCycleTimeData",
  "kind": "LinkedField",
  "name": "data",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "cycleTimeSeconds"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "insightsDevelopmentQuery",
    "selections": [
      (v10/*: any*/),
      {
        "concreteType": "DevOpsMetrics",
        "kind": "LinkedField",
        "name": "devOpsMetrics",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "DevOpsMetricsCycleTime",
            "kind": "LinkedField",
            "name": "cycleTime",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "cycleTimeMetrics",
                "plural": true,
                "selections": [
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "insightsDevelopmentQuery",
    "selections": [
      (v10/*: any*/),
      {
        "concreteType": "DevOpsMetrics",
        "kind": "LinkedField",
        "name": "devOpsMetrics",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "DevOpsMetricsCycleTime",
            "kind": "LinkedField",
            "name": "cycleTime",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "cycleTimeMetrics",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6682ac2a0f141c2c47c17b07f965669530319e5d7dd3dd5b937e8416fcd952c4",
    "metadata": {},
    "name": "insightsDevelopmentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "74d59cb23a4c44651c4a7c07702b704d";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
